module.exports = __webpack_public_path__ + "static/media/a_64k.b49eea65.mp3";